<template>
  <div class="liquor-search-bar">
    <el-popover
      ref="popover"
      placement="bottom-start"
      width="390"
      trigger="focus"
      :visible-arrow="false"
    >
      <div
        class="es-search-result-tabs"
        @mousewheel.prevent="onMouseWheel"
        v-loading="queryLoading"
      >
        <div class="tab-head">
          <div
            class="tab-head-item"
            :class="{'tab-head-item-active': index === current}"
            v-for="(item, index) in results"
            :key="index"
            @mouseover="current = index; y = 0"
          >{{item.type}}</div>
        </div>
        <div
          class="tab-body"
          v-for="(item, index) in results"
          :key="index"
          v-show="index === current"
          :style="item.list.length >= 4 ? 'height: 560px' : 'height: 260px'"
        >
          <div class="tab-body-head">共搜索出{{item.total}}条{{item.type}}信息</div>
          <div class="tab-body-last">
            <div
              class="tab-body-item-list"
              v-if="item.total"
              :style="`transform: translateY(${y}px);`"
              v-loading="moreLoading"
            >
              <div
                class="tab-body-item"
                v-for="(item, index) in item.list"
                :key="index"
                @click="goto(item)"
              >
                <div class="left" v-if="item.image">
                  <img :src="util.getFirstImage(item.image)" />
                </div>
                <div class="right" :style="item.image ? 'width: 290px' : 'width: 360px'">
                  <div class="title">{{item.name}}</div>
                  <div class="content">{{item.intro}}</div>
                </div>
              </div>
            </div>
            <img class="not-found" src="/liquor/暂无内容 （金装版）.png" v-else />
          </div>
        </div>
      </div>
    </el-popover>
    <el-input
      prefix-icon="el-icon-search"
      placeholder="请输入"
      v-model="query"
      @input="handleInput"
      v-popover:popover
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      query: "",
      current: 0,
      y: 0,
      dy: 0,
      results: [],
      from: 0,
      queryLoading: false,
      moreLoading: false
    };
  },
  computed: {},
  methods: {
    async handleInput(e) {
      console.log(e);
      if (e) {
        this.queryLoading = true;
        this.results = await this.ajax.doPost({
          packageName: "es",
          className: "search",
          methodName: "site",
          params: {
            query: e
          }
        });

        this.from = 0;
        this.queryLoading = false;

        console.log(this.results);
      }
    },
    async search() {
      if (this.moreLoading) {
        return;
      }
      if (
        this.results[this.current].list.length ===
        this.results[this.current].total
      ) {
        return;
      }
      if (this.query) {
        this.moreLoading = true;
        const response = await this.ajax.doPost({
          packageName: "es",
          className: "search",
          methodName: "site",
          params: {
            query: this.query,
            type: this.results[this.current].type,
            from: this.results[this.current].list.length
          }
        });

        const result = response.find(
          e => e.type === this.results[this.current].type
        );

        if (result && result.list.length > 0) {
          this.results[this.current].list = this.results[
            this.current
          ].list.concat(result.list);
        } else {
          this.$message("到底啦！");
        }

        this.moreLoading = false;

        console.log(this.results);
      }
    },
    onMouseWheel(e) {
      //   console.log(e);

      this.dy += e.wheelDeltaY;
      // 滚轮向下
      if (this.dy < -100) {
        const scrollHeight = this.results[this.current].list.length * 80;
        const maxHeight = 520;
        this.y -= 100;
        if (this.y + scrollHeight < maxHeight) {
          this.y = maxHeight - scrollHeight;

          this.search();
        }
        if (scrollHeight / 80 < 7) {
          this.y = 0;
        }
        this.dy = 0;
      }
      // 滚轮向上
      if (this.dy > 100) {
        this.y += 100;
        if (this.y > 0) {
          this.y = 0;
        }
        this.dy = 0;
      }
    },
    goto(e) {
      console.log(e);

      let url;

      switch (e.subType) {
        case "商品":
          url = `/liquor/detail/${e.id}`;
          break;
        case "产国":
          url = `/liquor/country/${e.id}`;
          break;
        case "产地":
          url = `/liquor/area/${e.id}`;
          break;
        case "词汇":
          url = `/liquor/dana?id=${e.id}`;
          break;
        default:
      }

      window.open(url);
    }
  }
};
</script>

<style lang="scss">
.liquor-search-bar {
  border-radius: 17px;
  .el-input {
    background: #f5f5f5;
    // border-radius: 5px;
    border-radius: 17px;
    height: 34px;
    line-height: 34px;
    .el-input__inner {
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      background: #f5f5f5;
      border: 1px solid #f5f5f5;
    }

    .el-input__inner:hover {
      border: 1px solid rgba(64, 177, 93, 1);
    }

    .el-input__prefix {
      height: 34px;
      line-height: 34px;
      color: #333;

      .el-input__icon {
        height: 34px;
        line-height: 34px;
      }

      input {
        border: 0;
      }
    }
  }

  .name {
    font-weight: bold;
  }

  .code {
    color: #999;
  }

  .el-autocomplete-suggestion {
    width: 300px !important;
  }
}

.es-search-result-tabs {
  width: 390px;
  max-height: 600px;

  .tab-head {
    width: 390px;
    height: 40px;

    .tab-head-item {
      width: 130px;
      display: inline-block;
      text-align: center;
      line-height: 40px;
      background: #efefef;
    }

    .tab-head-item-active {
      background: #e4c896;
    }
  }

  .tab-body {
    width: 390px;
    height: 560px;

    .not-found {
      width: 300px;
      margin: 45px;
    }

    .tab-body-head {
      height: 39px;
      line-height: 39px;
      font-size: 12px;
      color: rgba(109, 114, 120, 1);
      border-bottom: 1px solid #efefef;
      margin-left: 15px;
    }

    .tab-body-last {
      width: 390px;
      height: 520px;
      overflow: hidden;
    }

    .tab-body-item-list {
      transition: all 0.6s ease-out;
    }

    .tab-body-item {
      padding: 10px 15px 10px 15px;
      cursor: pointer;
      .left {
        vertical-align: top;
        display: inline-block;
        width: 50px;
        height: 50px;
        padding: 5px;
        margin-right: 10px;
        text-align: center;

        background: #fafafa;
        overflow: hidden;
        img {
          height: 50px;
        }
      }

      .right {
        vertical-align: top;
        display: inline-block;
        width: 290px;
        .title {
          vertical-align: top;
          height: 26px;
          line-height: 20px;
          color: black;
          font-weight: bold;
        }

        .content {
          height: 34px;
          font-size: 12px;
          color: rgba(51, 51, 51, 1);
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-clamp: 2;
        }
      }
    }

    .tab-body-item:hover {
      background: #fff3de;
    }
  }
}

.el-popover--plain {
  padding: 0;
}

.el-popover {
  border-radius: 0;
  border: 0;
  padding: 0;
}
</style>
